module.exports = "<div *ngIf=\"message\" class=\"m-alert m-alert--outline alert alert-{{message.type}} alert-dismissible\" role=\"alert\">\n\t<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" (click)=\"click.emit($event)\"></button>\n\t<span>{{message.text}}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/alert/alert.component.html
// module id = ../../../../../src/app/shared/alert/alert.component.html
// module chunks = main